import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// ข้อมูลภาษา
const languages = {
  th: {
    name: 'ไทย',
    flag: '🇹🇭',
    code: 'th'
  },
  en: {
    name: 'English',
    flag: '🇺🇸',
    code: 'en'
  },
  ja: {
    name: '日本語',
    flag: '🇯🇵',
    code: 'ja'
  },
  zh: {
    name: '中文',
    flag: '🇨🇳',
    code: 'zh'
  }
};

// คำแปลสำหรับแต่ละภาษา
const translations = {
  th: {
    // Navbar
    login: 'เข้าสู่ระบบ',
    register: 'ลงทะเบียน',
    dashboard: 'แดชบอร์ด',
    editProfile: 'แก้ไขโปรไฟล์',
    logout: 'ออกจากระบบ',
    hello: 'สวัสดี',
    
    // Home
    welcome: 'ยินดีต้อนรับสู่ Mellow App!',
    pleaseLogin: 'กรุณาเข้าสู่ระบบหรือลงทะเบียนเพื่อดำเนินการต่อ',
    
    // 404
    notFound: 'ไม่พบหน้าเว็บ',
    pageNotFound: 'หน้าที่คุณกำลังค้นหาไม่มีอยู่',
    goHome: 'กลับหน้าหลัก',
    
    // Login
    username: 'ชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    loggingIn: 'กำลังเข้าสู่ระบบ...',
    loginSuccess: 'เข้าสู่ระบบสำเร็จ! ยินดีต้อนรับ',
    loginError: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ กรุณาลองใหม่อีกครั้ง',
    noAccount: 'ยังไม่มีบัญชี?',
    registerHere: 'ลงทะเบียนที่นี่',
    welcomeBack: 'ยินดีต้อนรับกลับ!',
    loginSubtitle: 'เข้าสู่ระบบเพื่อเข้าถึงบัญชีของคุณ',
    orContinueWith: 'หรือเข้าสู่ระบบด้วย',
    show: 'แสดง',
    hide: 'ซ่อน',
    
    // Register
    createAccount: 'สร้างบัญชีใหม่',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    registering: 'กำลังลงทะเบียน...',
    registerSuccess: 'ลงทะเบียนสำเร็จ! กำลังนำคุณไปยังหน้าเข้าสู่ระบบ...',
    registerError: 'เกิดข้อผิดพลาดในการลงทะเบียน กรุณาลองใหม่อีกครั้ง',
    hasAccount: 'มีบัญชีอยู่แล้ว?',
    loginHere: 'เข้าสู่ระบบ',
    joinUs: 'เข้าร่วมกับเรา!',
    registerSubtitle: 'สร้างบัญชีใหม่เพื่อเริ่มต้นการเดินทางของคุณ',
    byRegistering: 'การลงทะเบียนถือว่าคุณยอมรับ',
    termsOfService: 'เงื่อนไขการให้บริการ',
    and: 'และ',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    
    // Edit Profile
    editData: 'แก้ไขข้อมูล',
    profileData: 'ข้อมูลโปรไฟล์',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    currentPassword: 'รหัสผ่านปัจจุบัน',
    newPassword: 'รหัสผ่านใหม่',
    saveData: 'บันทึกข้อมูล',
    updating: 'กำลังอัปเดต...',
    changingPassword: 'กำลังเปลี่ยนรหัสผ่าน...',
    updateSuccess: 'อัปเดตข้อมูลโปรไฟล์สำเร็จ! ข้อมูลของคุณได้รับการบันทึกแล้ว',
    passwordChangeSuccess: 'เปลี่ยนรหัสผ่านสำเร็จ! รหัสผ่านใหม่ของคุณได้รับการบันทึกแล้ว',
    updateError: 'เกิดข้อผิดพลาดในการอัปเดตโปรไฟล์ กรุณาลองใหม่อีกครั้ง',
    passwordChangeError: 'เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน กรุณาลองใหม่อีกครั้ง',
    
    // Validation
    fillAllFields: 'กรุณากรอกข้อมูลให้ครบทุกช่อง',
    usernameMinLength: 'ชื่อผู้ใช้ต้องมีอย่างน้อย 3 ตัวอักษร',
    passwordMinLength: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
    passwordMismatch: 'รหัสผ่านไม่ตรงกัน',
    invalidEmail: 'กรุณากรอกอีเมลให้ถูกต้อง',
    connectionError: 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต',
    
    // Logout
    logoutSuccess: 'ออกจากระบบสำเร็จ! ขอบคุณที่ใช้งาน',
    
    // Language
    language: 'ภาษา',
    selectLanguage: 'เลือกภาษา',
    
    // Session
    sessionExpired: 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง',
    
    // Sidebar & Navigation
    log: 'บันทึก',
    settings: 'ตั้งค่า',
    help: 'ช่วยเหลือ',
    myTrips: 'การเดินทางของฉัน',
    manageSubscription: 'จัดการการสมัครสมาชิก',
    contact: 'ติดต่อ',
    planTrip: 'วางแผนการเดินทาง',
    admin: 'ผู้ดูแลระบบ',
    adminDashboard: 'แดชบอร์ดผู้ดูแลระบบ',
    quickActions: 'การดำเนินการด่วน',
    role: 'บทบาท',
    
    // Form Labels
    email: 'อีเมล',
    userId: 'รหัสผู้ใช้',
    
    // Placeholders
    enterUsername: 'กรอกชื่อผู้ใช้',
    enterEmail: 'กรอกอีเมล',
    enterPassword: 'กรอกรหัสผ่าน',
    enterCurrentPassword: 'กรอกรหัสผ่านปัจจุบัน',
    enterNewPassword: 'กรอกรหัสผ่านใหม่',
    
    // Sidebar Actions
    expandSidebar: 'ขยายแถบด้านข้าง',
    collapseSidebar: 'ย่อแถบด้านข้าง',
    
    // Loading States
    loading: 'กำลังโหลด...',
    pleaseWait: 'กรุณารอสักครู่...',
    
    // UI Elements
    close: 'ปิด',
    
    // Analytics
    activityLogs: 'บันทึกการเข้าใช้งาน',
    showing: 'แสดง',
    of: 'จาก',
    records: 'รายการ',
    dateTime: 'วันที่และเวลา',
    status: 'สถานะ',
    ipAddress: 'IP Address',
    userAgent: 'User Agent',
    success: 'สำเร็จ',
    failed: 'ล้มเหลว',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    page: 'หน้า',
    noLoginLogs: 'ไม่มีบันทึกการเข้าใช้งาน',
    helpDescription: 'ส่งข้อความถึงเราเพื่อขอความช่วยเหลือหรือรายงานปัญหา',
    subject: 'หัวข้อ',
    message: 'ข้อความ',
    enterSubject: 'ใส่หัวข้อ (ไม่บังคับ)',
    enterMessage: 'ใส่ข้อความของคุณที่นี่...',
    submit: 'ส่งข้อความ',
    sending: 'กำลังส่ง...',
    messageRequired: 'กรุณาใส่ข้อความ',
    messageSentSuccess: 'ส่งข้อความสำเร็จแล้ว',
    messageSentError: 'เกิดข้อผิดพลาดในการส่งข้อความ',
    messageHistory: 'ประวัติข้อความ',
    noMessages: 'ยังไม่มีข้อความ',
    pending: 'รอดำเนินการ',
    inProgress: 'กำลังดำเนินการ',
    resolved: 'แก้ไขแล้ว',
    adminResponse: 'คำตอบจากผู้ดูแลระบบ',
    //page: 'หน้า',
    of: 'จาก',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    myTripsDescription: 'จัดการการเดินทางของคุณและดูประวัติการเดินทาง',
    noTripsYet: 'ยังไม่มีการเดินทาง',
    noTripsDescription: 'คุณยังไม่ได้เพิ่มการเดินทางใดๆ เริ่มต้นด้วยการเพิ่มการเดินทางแรกของคุณ',
    addFirstTrip: 'เพิ่มการเดินทางแรก',
    featureComingSoon: 'ฟีเจอร์นี้จะมาเร็วๆ นี้',
    destination: 'จุดหมายปลายทาง',
    date: 'วันที่',
    duration: 'ระยะเวลา',
    view: 'ดู',
    edit: 'แก้ไข',
    delete: 'ลบ',
    subscriptionDescription: 'จัดการแผนการสมัครสมาชิกและการชำระเงินของคุณ',
    subscriptionComingSoon: 'ระบบจัดการการสมัครสมาชิกจะมาเร็วๆ นี้',
    upgradePlan: 'อัปเกรดแผน',
    currentPlan: 'แผนปัจจุบัน',
    active: 'ใช้งาน',
    inactive: 'ไม่ใช้งาน',
    planType: 'ประเภทแผน',
    nextBilling: 'การเรียกเก็บเงินครั้งถัดไป',
    autoRenew: 'ต่ออายุอัตโนมัติ',
    enabled: 'เปิดใช้งาน',
    disabled: 'ปิดใช้งาน',
    updatePayment: 'อัปเดตการชำระเงิน',
    cancelSubscription: 'ยกเลิกการสมัครสมาชิก',
    availablePlans: 'แผนที่มีให้',
    month: 'เดือน',
    upgrade: 'อัปเกรด',
    home: 'หน้าแรก',
    ourServices: 'บริการของเรา',
    tripExamples: 'ตัวอย่างแผนเที่ยว',
    customerReviews: 'รีวิวลูกค้า',
    packagePricing: 'แพ็กเกจราคา',
    bookingSteps: 'ขั้นตอนการจอง',
    carWithDriver: 'รถพร้อมคนขับ',
    contactUs: 'ติดต่อเรา'
  },
  en: {
    // Navbar
    login: 'Login',
    register: 'Register',
    dashboard: 'Dashboard',
    editProfile: 'Edit Profile',
    logout: 'Logout',
    hello: 'Hello',
    
    // Home
    welcome: 'Welcome to Mellow App!',
    pleaseLogin: 'Please login or register to continue',
    
    // 404
    notFound: 'Page Not Found',
    pageNotFound: 'The page you are looking for does not exist',
    goHome: 'Go to Home',
    
    // Login
    username: 'Username',
    password: 'Password',
    loggingIn: 'Logging In...',
    loginSuccess: 'Login successful! Welcome',
    loginError: 'Login failed. Please try again',
    noAccount: "Don't have an account?",
    registerHere: 'Register here',
    welcomeBack: 'Welcome back!',
    loginSubtitle: 'Login to access your account',
    orContinueWith: 'or continue with',
    show: 'Show',
    hide: 'Hide',
    
    // Register
    createAccount: 'Create Account',
    confirmPassword: 'Confirm Password',
    registering: 'Registering...',
    registerSuccess: 'Registration successful! Redirecting to login...',
    registerError: 'Registration failed. Please try again',
    hasAccount: 'Already have an account?',
    loginHere: 'Login here',
    joinUs: 'Join us!',
    registerSubtitle: 'Create an account to start your journey',
    byRegistering: 'By registering, you agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    
    // Edit Profile
    editData: 'Edit Data',
    profileData: 'Profile Data',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    saveData: 'Save Data',
    updating: 'Updating...',
    changingPassword: 'Changing Password...',
    updateSuccess: 'Profile updated successfully! Your data has been saved',
    passwordChangeSuccess: 'Password changed successfully! Your new password has been saved',
    updateError: 'Failed to update profile. Please try again',
    passwordChangeError: 'Failed to change password. Please try again',
    
    // Validation
    fillAllFields: 'Please fill in all fields',
    usernameMinLength: 'Username must be at least 3 characters',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordMismatch: 'Passwords do not match',
    invalidEmail: 'Please enter a valid email',
    connectionError: 'Connection error. Please check your internet connection',
    
    // Logout
    logoutSuccess: 'Logged out successfully! Thank you for using our app',
    
    // Language
    language: 'Language',
    selectLanguage: 'Select Language',
    
    // Session
    sessionExpired: 'Session expired. Please login again',
    
    // Sidebar & Navigation
    log: 'Log',
    settings: 'Settings',
    help: 'Help',
    myTrips: 'My Trips',
    manageSubscription: 'Manage Subscription',
    contact: 'Contact',
    planTrip: 'Plan Trip',
    admin: 'Admin',
    adminDashboard: 'Admin Dashboard',
    quickActions: 'Quick Actions',
    role: 'Role',
    
    // Form Labels
    email: 'Email',
    userId: 'User ID',
    
    // Placeholders
    enterUsername: 'Enter your username',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    enterCurrentPassword: 'Enter your current password',
    enterNewPassword: 'Enter your new password',
    
    // Sidebar Actions
    expandSidebar: 'Expand Sidebar',
    collapseSidebar: 'Collapse Sidebar',
    
    // Loading States
    loading: 'Loading...',
    pleaseWait: 'Please wait...',
    
    // UI Elements
    close: 'Close',
    
    // Analytics
    activityLogs: 'Login Activity Logs',
    showing: 'Showing',
    of: 'of',
    records: 'records',
    dateTime: 'Date & Time',
    status: 'Status',
    ipAddress: 'IP Address',
    userAgent: 'User Agent',
    success: 'Success',
    failed: 'Failed',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    noLoginLogs: 'No login logs found',
    helpDescription: 'Send us a message for help or to report issues',
    subject: 'Subject',
    message: 'Message',
    enterSubject: 'Enter subject (optional)',
    enterMessage: 'Enter your message here...',
    submit: 'Submit',
    sending: 'Sending...',
    messageRequired: 'Please enter a message',
    messageSentSuccess: 'Message sent successfully',
    messageSentError: 'Failed to send message',
    messageHistory: 'Message History',
    noMessages: 'No messages yet',
    pending: 'Pending',
    inProgress: 'In Progress',
    resolved: 'Resolved',
    adminResponse: 'Admin Response',
    page: 'Page',
    of: 'of',
    previous: 'Previous',
    next: 'Next',
    myTripsDescription: 'Manage your trips and view trip history',
    noTripsYet: 'No trips yet',
    noTripsDescription: 'You haven\'t added any trips yet. Start by adding your first trip',
    addFirstTrip: 'Add First Trip',
    featureComingSoon: 'This feature is coming soon',
    destination: 'Destination',
    date: 'Date',
    duration: 'Duration',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    subscriptionDescription: 'Manage your subscription plan and payment',
    subscriptionComingSoon: 'Subscription management system is coming soon',
    upgradePlan: 'Upgrade Plan',
    currentPlan: 'Current Plan',
    active: 'Active',
    inactive: 'Inactive',
    planType: 'Plan Type',
    nextBilling: 'Next Billing',
    autoRenew: 'Auto Renew',
    enabled: 'Enabled',
    disabled: 'Disabled',
    updatePayment: 'Update Payment',
    cancelSubscription: 'Cancel Subscription',
    availablePlans: 'Available Plans',
    month: 'Month',
    upgrade: 'Upgrade',
    home: 'Home',
    ourServices: 'Our Services',
    tripExamples: 'Trip Examples',
    customerReviews: 'Customer Reviews',
    packagePricing: 'Package Pricing',
    bookingSteps: 'Booking Steps',
    carWithDriver: 'Car with Driver',
    contactUs: 'Contact Us'
  },
  ja: {
    // Navbar
    login: 'ログイン',
    register: '登録',
    dashboard: 'ダッシュボード',
    editProfile: 'プロフィール編集',
    logout: 'ログアウト',
    hello: 'こんにちは',
    
    // Home
    welcome: 'Mellow Appへようこそ！',
    pleaseLogin: '続行するにはログインまたは登録してください',
    
    // 404
    notFound: 'ページが見つかりません',
    pageNotFound: 'お探しのページは存在しません',
    goHome: 'ホームに戻る',
    
    // Login
    username: 'ユーザー名',
    password: 'パスワード',
    loggingIn: 'ログイン中...',
    loginSuccess: 'ログイン成功！ようこそ',
    loginError: 'ログインに失敗しました。もう一度お試しください',
    noAccount: 'アカウントをお持ちでない方は',
    registerHere: 'こちらで登録',
    welcomeBack: 'ようこそ！',
    loginSubtitle: 'ログインしてアカウントにアクセス',
    orContinueWith: 'または',
    show: '表示',
    hide: '非表示',
    
    // Register
    createAccount: 'アカウント作成',
    confirmPassword: 'パスワード確認',
    registering: '登録中...',
    registerSuccess: '登録成功！ログインページにリダイレクトします...',
    registerError: '登録に失敗しました。もう一度お試しください',
    hasAccount: 'すでにアカウントをお持ちの方は',
    loginHere: 'こちらでログイン',
    joinUs: '一緒に参加しませんか！',
    registerSubtitle: 'アカウントを作成して旅程を始めましょう',
    byRegistering: '登録することで',
    termsOfService: '利用規約',
    and: 'および',
    privacyPolicy: 'プライバシーポリシー',
    
    // Edit Profile
    editData: 'データ編集',
    profileData: 'プロフィールデータ',
    changePassword: 'パスワード変更',
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    saveData: 'データ保存',
    updating: '更新中...',
    changingPassword: 'パスワード変更中...',
    updateSuccess: 'プロフィールが正常に更新されました！データが保存されました',
    passwordChangeSuccess: 'パスワードが正常に変更されました！新しいパスワードが保存されました',
    updateError: 'プロフィールの更新に失敗しました。もう一度お試しください',
    passwordChangeError: 'パスワードの変更に失敗しました。もう一度お試しください',
    
    // Validation
    fillAllFields: 'すべてのフィールドを入力してください',
    usernameMinLength: 'ユーザー名は3文字以上である必要があります',
    passwordMinLength: 'パスワードは6文字以上である必要があります',
    passwordMismatch: 'パスワードが一致しません',
    invalidEmail: '有効なメールアドレスを入力してください',
    connectionError: '接続エラー。インターネット接続を確認してください',
    
    // Logout
    logoutSuccess: '正常にログアウトしました！アプリをご利用いただきありがとうございます',
    
    // Language
    language: '言語',
    selectLanguage: '言語を選択',
    
    // Session
    sessionExpired: 'セッションが期限切れです。再度ログインしてください',
    
    // Sidebar & Navigation
    log: 'ログ',
    settings: '設定',
    help: 'ヘルプ',
    myTrips: 'マイトリップ',
    manageSubscription: 'サブスクリプション管理',
    contact: 'お問い合わせ',
    planTrip: '旅行計画',
    admin: '管理者',
    adminDashboard: 'ダッシュボード管理者',
    quickActions: 'クイックアクション',
    role: 'ロール',
    
    // Form Labels
    email: 'メールアドレス',
    userId: 'ユーザーID',
    
    // Placeholders
    enterUsername: 'ユーザー名を入力',
    enterEmail: 'メールアドレスを入力',
    enterPassword: 'パスワードを入力',
    enterCurrentPassword: '現在のパスワードを入力',
    enterNewPassword: '新しいパスワードを入力',
    
    // Sidebar Actions
    expandSidebar: 'サイドバーを展開',
    collapseSidebar: 'サイドバーを折りたたむ',
    
    // Loading States
    loading: '読み込み中...',
    pleaseWait: 'お待ちください...',
    
    // UI Elements
    close: '閉じる',
    
    // Analytics
    activityLogs: 'ログイン活動ログ',
    showing: '表示中',
    of: 'の',
    records: '件',
    dateTime: '日時',
    status: 'ステータス',
    ipAddress: 'IPアドレス',
    userAgent: 'ユーザーエージェント',
    success: '成功',
    failed: '失敗',
    previous: '前へ',
    next: '次へ',
    page: 'ページ',
    noLoginLogs: 'ログインログが見つかりません',
    helpDescription: 'ヘルプや問題報告のためのメッセージを送信してください',
    subject: '件名',
    message: 'メッセージ',
    enterSubject: '件名を入力してください（任意）',
    enterMessage: 'ここにメッセージを入力してください...',
    submit: '送信',
    sending: '送信中...',
    messageRequired: 'メッセージを入力してください',
    messageSentSuccess: 'メッセージが正常に送信されました',
    messageSentError: 'メッセージの送信に失敗しました',
    messageHistory: 'メッセージ履歴',
    noMessages: 'まだメッセージがありません',
    pending: '保留中',
    inProgress: '処理中',
    resolved: '解決済み',
    adminResponse: '管理者からの回答',
    page: 'ページ',
    of: '/',
    previous: '前へ',
    next: '次へ',
    myTripsDescription: 'マイトリップを管理し、マイトリップの履歴を確認',
    noTripsYet: 'まだトリップがありません',
    noTripsDescription: 'まだトリップを追加していません。最初のトリップを追加することから始めましょう',
    addFirstTrip: '最初のトリップを追加',
    featureComingSoon: 'この機能はまもなく登場',
    destination: '目的地',
    date: '日付',
    duration: '期間',
    view: '表示',
    edit: '編集',
    delete: '削除',
    subscriptionDescription: 'サブスクリプションプランを管理し、支払いを行う',
    subscriptionComingSoon: 'サブスクリプション管理システムはまもなく登場',
    upgradePlan: 'プランアップグレード',
    currentPlan: '現在のプラン',
    active: 'アクティブ',
    inactive: '非アクティブ',
    planType: 'プランタイプ',
    nextBilling: '次回請求',
    autoRenew: '自動更新',
    enabled: '有効',
    disabled: '無効',
    updatePayment: '支払い情報の更新',
    cancelSubscription: 'サブスクリプションのキャンセル',
    availablePlans: '利用可能なプラン',
    month: '月',
    upgrade: 'アップグレード',
    home: 'ホーム',
    ourServices: 'サービス',
    tripExamples: '旅行プラン例',
    customerReviews: 'お客様の声',
    packagePricing: '料金プラン',
    bookingSteps: '予約手順',
    carWithDriver: '運転手付き車両',
    contactUs: 'お問い合わせ'
  },
  zh: {
    // Navbar
    login: '登录',
    register: '注册',
    dashboard: '仪表板',
    editProfile: '编辑个人资料',
    logout: '退出登录',
    hello: '你好',
    
    // Home
    welcome: '欢迎使用 Mellow App！',
    pleaseLogin: '请登录或注册以继续',
    
    // 404
    notFound: '页面未找到',
    pageNotFound: '您要查找的页面不存在',
    goHome: '返回首页',
    
    // Login
    username: '用户名',
    password: '密码',
    loggingIn: '登录中...',
    loginSuccess: '登录成功！欢迎',
    loginError: '登录失败，请重试',
    noAccount: '还没有账户？',
    registerHere: '在此注册',
    welcomeBack: '欢迎回来！',
    loginSubtitle: '登录以访问您的账户',
    orContinueWith: '或者继续使用',
    show: '显示',
    hide: '隐藏',
    
    // Register
    createAccount: '创建账户',
    confirmPassword: '确认密码',
    registering: '注册中...',
    registerSuccess: '注册成功！正在跳转到登录页面...',
    registerError: '注册失败，请重试',
    hasAccount: '已有账户？',
    loginHere: '在此登录',
    joinUs: '加入我们！',
    registerSubtitle: '创建账户以开始您的旅程',
    byRegistering: '通过注册，您同意',
    termsOfService: '使用条款',
    and: '和',
    privacyPolicy: '隐私政策',
    
    // Edit Profile
    editData: '编辑数据',
    profileData: '个人资料数据',
    changePassword: '更改密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    saveData: '保存数据',
    updating: '更新中...',
    changingPassword: '更改密码中...',
    updateSuccess: '个人资料更新成功！您的数据已保存',
    passwordChangeSuccess: '密码更改成功！您的新密码已保存',
    updateError: '更新个人资料失败，请重试',
    passwordChangeError: '更改密码失败，请重试',
    
    // Validation
    fillAllFields: '请填写所有字段',
    usernameMinLength: '用户名至少需要3个字符',
    passwordMinLength: '密码至少需要6个字符',
    passwordMismatch: '密码不匹配',
    invalidEmail: '请输入有效的电子邮件',
    connectionError: '连接错误，请检查您的网络连接',
    
    // Logout
    logoutSuccess: '成功退出登录！感谢您使用我们的应用',
    
    // Language
    language: '语言',
    selectLanguage: '选择语言',
    
    // Session
    sessionExpired: '会话已过期，请重新登录',
    
    // Sidebar & Navigation
    log: '记录',
    settings: '设置',
    help: '帮助',
    myTrips: '我的行程',
    manageSubscription: '管理订阅',
    contact: '联系',
    planTrip: '规划行程',
    admin: '管理员',
    adminDashboard: '管理员仪表板',
    quickActions: '快速操作',
    role: '角色',
    
    // Form Labels
    email: '邮箱',
    userId: '用户ID',
    
    // Placeholders
    enterUsername: '输入用户名',
    enterEmail: '输入邮箱',
    enterPassword: '输入密码',
    enterCurrentPassword: '输入当前密码',
    enterNewPassword: '输入新密码',
    
    // Sidebar Actions
    expandSidebar: '展开侧边栏',
    collapseSidebar: '收起侧边栏',
    
    // Loading States
    loading: '加载中...',
    pleaseWait: '请稍候...',
    
    // UI Elements
    close: '关闭',
    
    // Analytics
    activityLogs: '登录活动日志',
    showing: '显示',
    of: '共',
    records: '条记录',
    dateTime: '日期时间',
    status: '状态',
    ipAddress: 'IP地址',
    userAgent: '用户代理',
    success: '成功',
    failed: '失败',
    previous: '上一页',
    next: '下一页',
    page: '第',
    noLoginLogs: '暂无登录日志',
    helpDescription: '向我们发送消息以获得帮助或报告问题',
    subject: '主题',
    message: '消息',
    enterSubject: '输入主题（可选）',
    enterMessage: '在此输入您的消息...',
    submit: '提交',
    sending: '发送中...',
    messageRequired: '请输入消息',
    messageSentSuccess: '消息发送成功',
    messageSentError: '发送消息失败',
    messageHistory: '消息历史',
    noMessages: '暂无消息',
    pending: '待处理',
    inProgress: '处理中',
    resolved: '已解决',
    adminResponse: '管理员回复',
    page: '页',
    of: '共',
    previous: '上一页',
    next: '下一页',
    myTripsDescription: '管理您的行程并查看行程历史',
    noTripsYet: '还没有行程',
    noTripsDescription: '您还没有添加任何行程。从添加您的第一个行程开始',
    addFirstTrip: '添加第一个行程',
    featureComingSoon: '这个功能即将到来',
    destination: '目的地',
    date: '日期',
    duration: '持续时间',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    subscriptionDescription: '管理您的订阅计划和付款',
    subscriptionComingSoon: '订阅管理系统即将到来',
    upgradePlan: '升级计划',
    currentPlan: '当前计划',
    active: '活跃',
    inactive: '不活跃',
    planType: '计划类型',
    nextBilling: '下次账单',
    autoRenew: '自动续费',
    enabled: '启用',
    disabled: '禁用',
    updatePayment: '更新付款信息',
    cancelSubscription: '取消订阅',
    availablePlans: '可用计划',
    month: '月',
    upgrade: '升级',
    home: '首页',
    ourServices: '我们的服务',
    tripExamples: '行程范例',
    customerReviews: '客户评价',
    packagePricing: '套餐价格',
    bookingSteps: '预订步骤',
    carWithDriver: '带司机的车辆',
    contactUs: '联系我们'
  }
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'th';
  });

  const changeLanguage = (languageCode) => {
    setCurrentLanguage(languageCode);
    localStorage.setItem('language', languageCode);
  };

  const t = (key) => {
    return translations[currentLanguage][key] || key;
  };

  const getCurrentLanguage = () => {
    return languages[currentLanguage];
  };

  const getAllLanguages = () => {
    return Object.values(languages);
  };

  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      changeLanguage,
      t,
      getCurrentLanguage,
      getAllLanguages
    }}>
      {children}
    </LanguageContext.Provider>
  );
}; 
